// Copy for the public landing page (all three designs), used as t("ui.landing.*").
// Numbers are formatted in code (formatNumber / formatMoney) and passed in as strings.
export default {
  nav: {
    features: "امکانات",
    plans: "قیمت‌ها",
    payment: "پرداخت",
    faq: "سوال‌ها",
    login: "ورود",
    account: "حساب کاربری",
  },
  hero: {
    eyebrow: "اشتراک فونتا پرو",
    title: "استوری‌هات رو با فونت‌های خاص بنویس",
    // the part of the title that gets the accent treatment
    titleEmphasis: "فونت‌های خاص",
    subtitle: "با اشتراک پرو همه فونت‌ها و پس‌زمینه‌ها باز می‌شن، هر فونتی بخوای اضافه می‌کنی و تبلیغی نمی‌بینی.",
    cta: "خرید اشتراک پرو",
    ctaRenew: "تمدید اشتراک",
    proUntil: "پرو هستی، {{days}} روز دیگه فعاله",
  },
  tape: {
    pause: "نگه داشتن نوار متن‌ها",
    play: "پخش نوار متن‌ها",
  },
  features: {
    title: "با پرو چی عوض می‌شه؟",
    items: {
      fonts: {
        title: "همه فونت‌ها باز می‌شن",
        body: "همه فونت‌های فارسی و انگلیسی داخل اپ، بدون قفل در اختیارته.",
      },
      backgrounds: {
        title: "همه پس‌زمینه‌ها باز می‌شن",
        body: "هر پس‌زمینه‌ای که توی اپ هست، بدون محدودیت پشت نوشته‌هات می‌شینه.",
      },
      import: {
        title: "هر فونتی بخوای اضافه کن",
        body: "فایل فونت دلخواهت رو از گوشی وارد اپ کن و باهاش استوری بنویس.",
      },
      ads: {
        title: "بدون تبلیغ",
        body: "دیگه وسط نوشتن هیچ تبلیغی نمی‌بینی.",
      },
    },
  },
  plans: {
    title: "پلنت رو انتخاب کن",
    subtitle: "همه پلن‌ها همه امکانات پرو رو دارن، فرقشون فقط مدت اشتراکه.",
    best: "به‌صرفه‌ترین",
    saving: "{{percent}} کمتر از ماهانه",
    months: "{{count}} ماه",
    buy: "خرید {{name}}",
    guestPrice: "قیمت دقیق رو بعد از ورود می‌بینی",
    // e.g. "به قیمت یه شات اسپرسو" (item from app/design/equivalents)
    equivalent: "به قیمت {{item}}",
    paymentNote: "پرداخت به صورت کارت به کارت انجام می‌شه و بعد از بررسی رسید، اشتراکت فعال می‌شه.",
    unavailable: "الان پلنی برای خرید در دسترس نیست. برای کمک به دایرکت اینستاگرام ما پیام بده.",
  },
  payment: {
    title: "پرداخت چطوریه؟",
    steps: {
      pick: { title: "یه پلن انتخاب کن", body: "از بین پلن‌های بالا، مدتی که می‌خوای رو بزن." },
      transfer: { title: "مبلغ رو کارت به کارت کن", body: "شماره کارت و اسم صاحب حساب بعد از انتخاب پلن نشونت داده می‌شه." },
      receipt: { title: "عکس رسید رو بفرست", body: "تصویر رسید واریز رو همون‌جا آپلود کن." },
      active: { title: "پرو فعال می‌شه", body: "بعد از بررسی رسید، اشتراک روی حسابت فعال می‌شه." },
    },
  },
  faq: {
    title: "سوال‌های پرتکرار",
    items: [
      {
        q: "چجوری از فونتا داخل اپ‌های دیگه هم استفاده کنم؟",
        a: "می‌تونین به صورت png خروجی بگیرین و توی گالری داشته باشینش، بعد داخل هر اپی که خواستین از تصویرش استفاده کنین.",
      },
      {
        q: "تو نسخه اندروید چطوری می‌تونم کپی کنم؟",
        a: "تو نسخه اندروید می‌تونین به صورت png خروجی بگیرین، توی گالری ذخیره‌اش کنین و بعد تو استوری ازش استفاده کنین.",
      },
    ],
    more: "سوالت اینجا نیست؟",
    moreBody: "تو دایرکت اینستاگرام فونتا بپرس، همون‌جا جواب می‌دیم.",
    instagram: "پیام در اینستاگرام",
  },
  footer: {
    tagline: "فونتا برای نوشتن استوری با فونت‌های فارسی و انگلیسیه.",
    terms: "قوانین استفاده",
    privacy: "حریم خصوصی",
    instagram: "اینستاگرام فونتا",
    rights: "© {{year}} فونتا",
  },
  // Only the Cobalt Paper (b) landing uses these.
  b: {
    fonts: { peyda: "پیدا", modam: "مدام", yekan: "ایران‌یکان" },
    weight: "وزن {{weight}}",
    specimen: {
      label: "جمله «امروز حالم خوبه» که بین فونت‌های پیدا، مدام و ایران‌یکان عوض می‌شه",
      sentence: "امروز حالم خوبه",
      alphabet: "آ ب پ ت ث ج چ",
      pause: "نگه داشتن نمونه فونت‌ها",
      play: "پخش نمونه فونت‌ها",
    },
    lock: { locked: "مخصوص پرو", open: "باز شد" },
    importAlt: "حروف چوبی قدیمی چاپ",
    stories: {
      title: "یه عکس، یه جمله، با فونتی که دوست داری",
      lead: "چند نمونه از استوری‌هایی که می‌شه با فونتا نوشت.",
      label: "نمونه استوری‌ها",
      prev: "نمونه‌های قبلی",
      next: "نمونه‌های بعدی",
      items: ["یه روز آروم و آبی", "جمعه‌ها مال خودمه", "تابستون یعنی همین", "بخند، هنوز وقت هست", "تولدت مبارک", "شب‌های شهر", "دلم برات تنگ شده", "با فونت خودت بنویس"],
    },
    plans: { monthly: "مناسب برای امتحان کردن", months: "ماه" },
  },
};
